import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatTreeModule } from "@angular/material/tree";
import { LocationStripComponent } from "./location-strip.component";
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { FormsModule } from "@angular/forms";

@NgModule({
  declarations: [LocationStripComponent],
  imports: [
    CommonModule,
    MatAutocompleteModule,
    MatTreeModule,
    FormsModule
  ],
  exports: [LocationStripComponent],
  providers: []
})
export class LocationStripModule { }

